export default function ChangePassword() {
  return <div className="p-6">Change Password Page</div>;
}